import type { ImageLoaderConfig, PlatformClientEnv } from '../types';

// Client-side env for the Storybook bundle. All VITE_*-backed integrations
// (Amplitude, Dash0 RUM, Cookiefirst) noop when their key is
// missing, so leaving everything undefined keeps stories deterministic and
// free of analytics / external calls. GTM container IDs are likewise
// undefined so the tracker plugin skips GTM init in stories.
export const env: PlatformClientEnv = {
  COOKIEFIRST_URL: undefined,
  AMPLITUDE_API_KEY: undefined,
  DASH0_RUM_ENDPOINT: undefined,
  DASH0_RUM_TOKEN: undefined,
  GTM_CONTAINER_ID: undefined,
  GTM_CONTAINER_ID_PREVIEW: undefined,
  DEV: import.meta.env.DEV,
};

// No `fallback` — Unpic detects supported CDNs from the URL (Unsplash,
// Cloudinary, etc.) and passes anything else through as a plain <img>.
// This avoids routing placeholder images (placehold.co, picsum, etc.)
// through the host-locked image-dummy.dev.understory.io proxy.
export const imageLoader: ImageLoaderConfig = {};
